/*****
 * ====================================================================================
 * Project: noloPathRelatedProducts jQuery Plugin
 * Description: provides support of various analytics for noloPath pages
 * Author: Ian Cruz @ Nolo
 * Version: 1.0.0
 * jQuery Version: 2.1.3
 * ====================================================================================
 */




// noloPathRelatedProducts JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloPathRelatedProducts PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var noloPathRelatedProducts = function (element, options) {
        this.$element = $(element);
        this.options  = $.extend(true, {}, noloPathRelatedProducts.DEFAULTS, this.getDataAttributeOptions(), options);
        this.mst      = $('#' + this.options.mustache).html();
        this.pid      = this.options.pid;
        this.location = this.options.location;
        this.source   = this.options.source;
        this.data     = this.options.data;
        this.retrieve = this.options.retrieve;

        if(this.retrieve === 'products'){
            this.type  = this.options.type;
            this.limit = this.options.limit;
        }

        // Initialize the plugin
        this.init();
    }




    // noloPathRelatedProducts PLUGIN NAME
    // ================================================================================
    noloPathRelatedProducts.NAME     = 'noloPathRelatedProducts';
    noloPathRelatedProducts.ALIAS    = 'noloPathGiftBasket';
    noloPathRelatedProducts.DATANAME = 'nolo.' + noloPathRelatedProducts.NAME;




    // noloPathRelatedProducts VERSION
    // ================================================================================
    noloPathRelatedProducts.VERSION = '1.0.0';




    // noloPathRelatedProducts DEFAULT OPTIONS
    // ================================================================================
    noloPathRelatedProducts.DEFAULTS = {
        'limit'    : 4,
        'mustache' : 'mst_form_related_products',
        'pid'      : 0,
        'type'     : 'category',
        'retries'  : 3,
        'retrieve' : 'products',
        'location' : null,
        'source'   : null,
        'data'     : null,
    }




    // noloPathRelatedProducts PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    noloPathRelatedProducts.prototype.init = function(){
        // if unsold && no products, the form summary should become visible only after this script finishes executing
        $('.form-case-summary').addClass('loading');

        switch(this.retrieve){
            case 'articles':
            this.getRelatedArticles();
            break;

            case 'ndr':
            if(location.pathname.includes('sem') && this.pid == 1081) {
                //getNDR controls the display of the summary, so do that here
                $('.form-case-summary').removeClass('loading');
            } else this.getNDR();
            break;

            case 'products':
            default:
            this.getRelatedProducts();
        }

    }

    noloPathRelatedProducts.prototype.getRelatedArticles = function() {
        var options = this.options;
        var postData = {
            'pid'   : this.pid,
        };
        var process = this;
        var callTimes = 0;
        var retries = options.retries;

        // create the promise
        var promise = {};
        var setPromiseConfig = function() {
            var config = $.ajax({
                type: 'POST',
                crossDomain: true,
                url: '/path2/service/getArticlesData',
                data: postData,
                dataType: 'json',
            });

            // resets the promise variable to allow retries
            promise = config
        };

        // Make the first request.
        setPromiseConfig();

        // Callback when success
        var successPromise = function(data, status, xhr) {
            if (($.isEmptyObject(data.related_articles) || data.related_articles.length === 0) && callTimes < retries) {
                // sometimes the practice area has configured related products, but server caching returns empty
                // redo the request up to the configured retry count
                setPromiseConfig();

                // repeat the success handler
                promise.done(successPromise);

                // increment call times
                callTimes++;

                if (callTimes === retries) {
                    process.centerFormSummary();
                }

                // bail out
                return false;
            } else {
                process.data = data;
                process.articlesFound = data.related_articles.length;
                callTimes = 0;

                // still no data? bail out
                if (data.related_articles && data.related_articles.articles && data.related_articles.articles.length === 0 && callTimes === 0){
                    return false;
                }

                // on successful retrieval, render the data
                return process.onAjaxSuccessSubmit(data, status, xhr);
            }
        };

        // on success, process data
        promise.done(successPromise);

        // catch ajax errors
        promise.fail(function(xhr, status, error){
            return process.onAjaxErrorSubmit(xhr, status, error);
        });
    }

    noloPathRelatedProducts.prototype.getNDR = function() {
        if ((this.pid == 96 && !location.pathname.includes('sem')) ||
             this.pid == 96 && document.querySelector("#nolopath[data-lead-type-clean='unsold']") != null ||
             this.pid == 96 && document.querySelector("#nolo-typ-ehcs[data-lead-type-clean='unsold']") != null) {
            //don't trigger NDR
            $('.form-case-summary').removeClass('loading');
            return;
        }
        var options = this.options;
        var baseDomain = options.baseDomain;
        if(!baseDomain) {
            var hostname = location.hostname.split(".");
            hostname.shift();
            baseDomain = hostname.join(".")
        }
        var postData = {
            'pid'      : this.pid,
            'location' : this.location,
            'source'   : this.source,
            'data'     : this.data,
            'firstName': options.firstName,
            'lastName' : options.lastName,
            'mail'     : decodeURIComponent(options.mail),//min-path3 tends to convert the email addr to encode version
            'phone'    : options.phone.replace("+",""),
            'skey'     : options.skey,
            'requestId': options.requestId,
            'baseDomain': baseDomain,
            'domainPath': window.location.pathname.split('/')[2],
            'qa': options.qa,
        };
        var process = this;
        var callTimes = 0;
        var retries = options.retries;

        if ([4, 1081, 96, 74, 16, 18, 88, 30, 83, 14].includes(this.pid)) {
            document.querySelector('body').classList.add('ndr-aop');
        }

        // create the promise
        var promise = {};
        var setPromiseConfig = function() {
            var config = $.ajax({
                type: 'POST',
                crossDomain: true,
                url: '/path2/service/getNDRData',
                data: postData,
                dataType: 'json',
            });
            // resets the promise variable to allow retries
            promise = config
        };

        // Make the first request.
        setPromiseConfig();

        // Callback when success
        var successPromise = function(data, status, xhr) {
            if (($.isEmptyObject(data.ndr_offer) || data.length === 0) && callTimes < retries) {
                // sometimes the practice area has configured related products, but server caching returns empty
                // redo the request up to the configured retry count
                setPromiseConfig();

                // repeat the success handler
                promise.done(successPromise);

                // increment call times
                callTimes++;

                if (callTimes === retries) {
                    process.centerFormSummary();
                }
                // bail out
                return false;
            } else {
                process.data = data;
                callTimes = 0;

                // on successful retrieval, append data to element
                return process.onAjaxSuccessSubmitNdr(data.ndr_offer);
            }
        };
        // on success, process data
        promise.done(successPromise);

        // catch ajax errors
        promise.fail(function(xhr, status, error){
            return process.onAjaxErrorSubmit(xhr, status, error);
        });
    }

    noloPathRelatedProducts.prototype.getRelatedProducts = function() {
        if(window.onlyNDR) {
            return;
        }
        var options = this.options;
        var postData = {
            'pid'   : this.pid,
            'type'  : this.type,
            'limit' : this.limit
        };
        var process = this;
        var callTimes = 0;
        var retries = options.retries;

        // create the promise
        var promise = {};
        var setPromiseConfig = function() {
            var config = $.ajax({
                type: 'POST',
                crossDomain: true,
                url: '/path2/service/getProductsData',
                data: postData,
                dataType: 'json',
            });

            // resets the promise variable to allow retries
            promise = config
        };

        // Make the first request.
        setPromiseConfig();

        // Callback when success
        var successPromise = function(data, status, xhr) {
            if (($.isEmptyObject(data.related_products) || data.related_products.length === 0) && callTimes < retries) {
                // sometimes the practice area has configured related products, but server caching returns empty
                // redo the request up to the configured retry count
                setPromiseConfig();

                // repeat the success handler
                promise.done(successPromise);

                // increment call times
                callTimes++;

                if (callTimes === retries) {
                    process.centerFormSummary();
                }

                // bail out
                return false;
            } else {
                process.data = data;
                process.productsFound = data.related_products.length;
                callTimes = 0;

                // on successful retrieval, render the data
                return process.onAjaxSuccessSubmit(data, status, xhr);
            }
        };

        // on success, process data
        promise.done(successPromise);

        // catch ajax errors
        promise.fail(function(xhr, status, error){
            return process.onAjaxErrorSubmit(xhr, status, error);
        });
    }


    noloPathRelatedProducts.prototype.getDataAttributeOptions = function(){
        var options = this.$element.data();
        return options;
    }


    noloPathRelatedProducts.prototype.render = function(template, target, data, partials){
        // use Mustache.js to render stuff to the page
        Mustache.parse(template);
        var rendered = Mustache.render(template, data, partials);
        target.html(rendered);
        this.initializeCarousel();
        return;
    }


    noloPathRelatedProducts.prototype.onAjaxSuccessSubmitNdr = function(data) {
        // ajax call with bad pid still returns empty array. Check for this
        if (!$.isEmptyObject(data)){
            this.$element.append(data);
            if(!location.pathname.includes('sem')) $("body").addClass('ndr-render');
            this.$element.show();
            $('.form-case-summary').removeClass('loading');
            if(location.href.includes('disqualified')){
                //hide the DIY even leads type is network
                $("body").addClass('disqualified-route');
            }
        } else if(!location.pathname.includes('sem')) {
            $("body").addClass('ndr-absent');
        }
    }

    noloPathRelatedProducts.prototype.onAjaxSuccessSubmit = function(data, status, xhr){
        this.render(this.mst, this.$element, data);
        $('.form-case-summary').removeClass('loading');
        this.$element.show();
    }


    noloPathRelatedProducts.prototype.onAjaxErrorSubmit = function(xhr, status, error, $field){
        var data = {
            'xhr': xhr,
            'status': status,
            'error': error
        };

        // in case there is another error type, use this to generate a generic one
        this.setStatusError('genericOnAjaxErrorSubmit', 'error', 'Unable to process your request due to a server error', data);

        return false;
    }


    noloPathRelatedProducts.prototype.setStatusError = function(id, status, errorMessage, errorData){
        return false;
    }


    noloPathRelatedProducts.prototype.centerFormSummary = function() {
        this.$element.addClass('no-display');
        var dataPathId = $('#nolopath').attr('data-path-id');
        // Do not center form case summary if providers list exists
        if (dataPathId == "min-path4" || dataPathId == "min-path7" || dataPathId == "min-path3" || $('.form-providers-summary').length || $('.form-related-products').length) {
            $('.form-case-summary').removeClass('loading');
        } else {
            $('.form-case-summary').addClass('center').removeClass('loading');
        }
    }


    noloPathRelatedProducts.prototype.initializeCarousel = function () {
        var relatedProductsSelector = $('.related-products-carousel');
        if (relatedProductsSelector.length > 0) {
            relatedProductsSelector.slick({
                autoplay: true,
                dots: false,
                draggable: false,
                infinite: true,
                slide: '.media',
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: false
            });
            return;
        } else {
            return;
        }
    };

    // noloPathRelatedProducts PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(noloPathRelatedProducts.DATANAME);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(noloPathRelatedProducts.DATANAME, (data = new noloPathRelatedProducts(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[noloPathRelatedProducts.NAME];

    // assign the noloPathRelatedProducts PLUGIN DEFINITION
    $.fn[noloPathRelatedProducts.NAME] = Plugin;

    // assign the noloPathRelatedProducts PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[noloPathRelatedProducts.NAME]['constructor'] = noloPathRelatedProducts;

    // assign an alias
    $.fn[noloPathRelatedProducts.ALIAS] = $.fn[noloPathRelatedProducts.NAME];




    // noloPathRelatedProducts NO CONFLICT
    // ================================================================================
    $.fn[noloPathRelatedProducts.NAME]['noConflict'] = function () {
        $.fn[noloPathRelatedProducts.NAME] = old;
        return this;
    }




    // noloPathRelatedProducts DATA-API
    // ================================================================================
    $(document).ready(function(){
        // auto-initialize elements that contain the 'data-toggle="noloPathRelatedProducts"' attribute
        var $elm = $('[data-toggle="noloPathRelatedProducts"], [data-toggle="noloPathGiftBasket"]');

        // pass a blank object to simplify the initialization
        // default plugin options and data attribute configuration options will be used for data-api initialization
        var option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });
}(jQuery, window, document);
